import React from "react";
import Link from "gatsby-link";
import Bus from "../../utils/bus";
import ClassNames from "classnames";
let BUS = new Bus();

class CartLineItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFocused: false,
      quantity: null,
      discount: props.discount
    };

    this.addToCart = this.addToCart.bind(this);
    this.removeItemFromCart = this.removeItemFromCart.bind(this);
    this.renderQuantity = this.renderQuantity.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.returnProductLink = this.returnProductLink.bind(this);
    this.closeCart = this.closeCart.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
    this.updateDiscount = this.updateDiscount.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      BUS.trigger("CLOSE_CART");
    }
  }

  componentWillReceiveProps(next) {
    // console.log("CartLineItem.componentWillReceiveProps", next);
  }

  componentWillUnmount() {
    BUS.stopListening("DISCOUNT_APPLIED", this.updateDiscount);
  }

  componentDidMount() {
    BUS.listen("DISCOUNT_APPLIED", this.updateDiscount);
  }

  updateDiscount() {
    this.setState({
      discount: 0.2
    });
  }

  closeCart() {
    BUS.trigger("CLOSE_CART");
  }

  returnProductLink() {
    switch (this.props.product.id) {
      case "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc0OTM1MzMzNjg3Ng==":
        return "/products/yoga-flow";
        break;
      case "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc0OTM1NzIwMzUwMA==":
        return "/products/protein-joe";
        break;
      default:
        return "/products/protein-joe";
    }
  }

  addToCart(e, variantId) {
    this.props.addItem(e, variantId);
  }

  handleCartUpdate(e, variantId) {
    this.props.handleCartUpdate(e, variantId);
  }

  removeItemFromCart(variantId, productName) {
    this.props.removeFromCart(variantId, productName);
  }

  renderQuantity(variantId) {
    let quantity = this.props.checkout.lineItems.find((item, i) => {
      return variantId === item.variant.id;
    });
    return quantity === undefined ? 0 : quantity.quantity;
  }

  formatPrice(price) {
    price = Number(price);
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "USD"
    })
      .format(price)
      .replace("US$", "");
  }

  appendToFilename ( filename, string ) {
    var dotIndex = filename.lastIndexOf( "." );
    if ( dotIndex == -1 ) {
        return filename + string;
    } else {
        return filename.substring( 0, dotIndex ) + string + filename.substring( dotIndex );
    }
  }

  render() {
    const product = this.props.product;
    const image = this.appendToFilename( product.images[0].src, '_144x166' );
    const variant = product.variants[0];
    const quantity = Number(this.renderQuantity(variant.id));
    const price = Number(variant.price);

    return (
      <div className="Cart-line-item">
        <div className="left">
          <Link
            className="image"
            to={this.returnProductLink()}
            onClick={this.closeCart}
          >
            <img src={image} />
          </Link>
        </div>
        <div className="right">
          <Link
            to={this.returnProductLink()}
            className="title size--m"
            onClick={this.closeCart}
          >
            {product.title}
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.36 17.96">
                <path d="M0 9a8.85 8.85 0 0 1 9.14-9 8.89 8.89 0 0 1 9.22 9 8.9 8.9 0 0 1-9.22 9A8.85 8.85 0 0 1 0 9zm16.34 0c0-4.32-2.84-7.12-7.2-7.12A6.79 6.79 0 0 0 2 9a6.83 6.83 0 0 0 7.12 7.17c4.38-.04 7.22-2.85 7.22-7.17zM11 4.5h2.41v5.29H10v2.92H4.35v-2.42h3.24V7.38H11z" />
              </svg>
            </span>
          </Link>
          <Link
            onClick={this.closeCart}
            to={this.returnProductLink()}
            className="view light size--s"
          >
            View Product
          </Link>
          <div className="description size--xs light">
            {product.variants[0].title}
          </div>
          <span
            className={ClassNames("item-price size--xs light", {
              "has-discount": this.state.discount !== 0
            })}
          >
            ${this.formatPrice(variant.price)}
          </span>

          {this.state.discount !== 0 && (
            <span className="discounted-price price size--xs light">
              ${this.formatPrice(variant.price * (1 - this.state.discount))}
            </span>
          )}

          <br />
          {!variant.id ? (
            <div className="sold-out">Sold Out</div>
          ) : (
            <div className="add-quantity-details">
              <div className="quantity light size--xs">Quantity</div>
              <button
                className="subtract"
                onClick={() =>
                  this.removeItemFromCart(variant.id, product.title)
                }
              >
                <span>-</span>
              </button>
              <span className="quantity-input">
                {this.renderQuantity(variant.id)}
              </span>

              <button
                onClick={e => this.addToCart(e, variant.id)}
                className="add"
              >
                <span>+</span>
              </button>
            </div>
          )}

          <span
            className={ClassNames({
              "size--m": true,
              lineItemPrice: true,
              "is-zero": quantity === 0
            })}
          >
            ${this.formatPrice(price * (1 - this.state.discount) * quantity)}
          </span>
        </div>
      </div>
    );
  }
}

export default CartLineItem;



// WEBPACK FOOTER //
// ./src/components/cart/cart-line-item.js